var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useDeferredValue, } from 'react';
import './App.scss';
import Search from './components/Search';
import Results from './components/Results';
import { objToQueryString, makeid } from './utils/helpers';
var ART_API_KEY = "".concat(process.env.REACT_APP_ART_API_KEY);
export default function App() {
    var _a = useState(null), title = _a[0], setTitle = _a[1];
    var _b = useState(null), searchTrigger = _b[0], setSearchTrigger = _b[1];
    var _c = useState({ records: {}, id: '' }), recordsState = _c[0], setRecordsState = _c[1];
    var deferredRecordsState = useDeferredValue(recordsState);
    // const [returnError, setReturnError] = useState(false)
    var fetchPaintingData = useCallback(function () {
        var queryString = function () {
            return objToQueryString({
                apikey: ART_API_KEY,
                title: title,
                classification: 'Paintings',
                hasimage: 1,
                q: 'imagepermissionlevel:0 AND (verificationlevel:3 OR verificationlevel:4)',
                sort: 'random',
            });
        };
        fetch("https://api.harvardartmuseums.org/object?".concat(queryString()), {
            method: 'GET',
        })
            .then(function (response) { return response.json(); })
            .then(function (responseData) {
            setRecordsState({
                records: responseData.records,
                id: makeid(6),
            });
        })
            .catch(function (error) {
            // setReturnError(true)
            console.log(error);
        });
    }, [title]);
    useEffect(function () {
        ;
        (title || title === '') && fetchPaintingData();
    }, [fetchPaintingData, title]);
    return (_jsxs("div", __assign({ id: "App", className: "App" }, { children: [_jsx(Search, { update: setTitle, searchTrigger: searchTrigger }), deferredRecordsState && deferredRecordsState.id !== '' && (_jsx(_Fragment, { children: _jsx(Results //@ts-ignore
                , { paintings: deferredRecordsState.records, resultsId: deferredRecordsState.id, randomSearch: setSearchTrigger }) }))] })));
}
